export class GraphAuthChallengeError extends Error {
  readonly claimsChallenge?: string

  constructor(message: string, claimsChallenge?: string) {
    super(message)
    this.name = 'GraphAuthChallengeError'
    this.claimsChallenge = claimsChallenge
  }
}
